<template>
  <svg aria-hidden="true" width="24" height="24" fill="none" viewBox="0 0 24 24" ...attributes>
    <path stroke-linecap="round" stroke-linejoin="round" d="M4.75 6.75L9.25 4.75V17.25L4.75 19.25V6.75Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M14.75 6.75L19.25 4.75V17.25L14.75 19.25V6.75Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M14.75 6.75L9.25 4.75V17.25L14.75 19.25V6.75Z" />
  </svg>
</template>
